export default "__VITE_ASSET__LBmoEmnTx4MI7lEKmdDiZQ__"